import { render, staticRenderFns } from "./SpecHistoryPanel.vue?vue&type=template&id=35f6f468&scoped=true&lang=pug&"
import script from "./SpecHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./SpecHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpecHistoryPanel.vue?vue&type=style&index=0&id=35f6f468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6f468",
  null
  
)

export default component.exports